export function getUtcTimestampSeconds() {
	const now = new Date
	const utcTimestamp = Date.UTC( now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds() )
	const utcTimestampSeconds = Math.round( utcTimestamp / 1000 )

	return utcTimestampSeconds
}

export function getHhMmSsFromSeconds( secondsTotal ) {
	let hoursString = '',
		minutesString = '',
		secondsString = ''

	secondsTotal = Math.floor( secondsTotal )

	let hours = Math.max( 0, Math.floor( secondsTotal / 3600 ) )
	secondsTotal %= 3600
	let minutes = Math.max( 0, Math.floor( secondsTotal / 60 ) )
	let seconds = Math.max( 0, secondsTotal % 60 )

	if ( hours ) {
		hoursString = `${hours}:`
	}

	if ( hoursString && minutes ) {
		minutes = String( minutes ).padStart( 2, '0' )
	}

	minutesString = `${minutes}:`

	secondsString = String( seconds ).padStart( 2, '0' )

	return `${hoursString}${minutesString}${secondsString}`
}
